<script setup lang="ts">
import CombineRollbackContent from "@/components/DailyReportEdit/CombineRollback/CombineRollbackContent.vue";
import getDeliveryPlanVehicleInformation from '@/types/responses/getDeliveryPlanVehicleInformation';
import RegisterModal from '@/components/DailyReportEdit/CombineRollback/RegisterModal.vue';
import ButtonArea from '@/components/DailyReportEdit/CombineRollback/ButtonArea.vue';
import combineDailyReportsResponse from 'src/types/responses/combineDailyReports';
import CompleteModal from '@/components/DailyReportEdit/Split/CompleteModal.vue';
import { useAuth } from '@/services/user/Auth0UserProvider';
import Api from '@/services/api/ApiServiceFabrick';
import { useRouter } from 'vue-router';
import i18n from '@/lang/i18n';
import { ref } from 'vue';

const props = defineProps<{
  deliveryPlan: getDeliveryPlanVehicleInformation
  showFlash: (message: string, type: string, fadeout: boolean) => void
}>()

const { loginWithRedirect } = useAuth();
const router = useRouter();
const isOpenConfirmModal = ref<boolean>(false);
const isDisplayCompleteModal = ref<boolean>(false);
const hasError = ref<boolean>(false);

function execCombineRollback() {
  Api().combineRollbackDailyReports(props.deliveryPlan.delivery_plan_id).then((data: combineDailyReportsResponse) => {
    if (data.status) {
      return isDisplayCompleteModal.value = true;
    }
    hasError.value = true;
    props.showFlash(i18n.global.t('pages.dailyReports.splitForm.failedMessage'), 'error', true);
  }).catch((error) => {
    errorHandler(error);
  })
}

function errorHandler(error: any) {
  const res = error.response
  switch (res.status) {
    case 401:
      loginWithRedirect({ appState: { targetUrl: location.pathname } })
      break
    case 403:
      location.reload()
      break
    case 422:
      hasError.value = true;
      props.showFlash(res.data.errors.delivery_plan_id.join(', '), 'error', true);
      break
  }
}

function moveDailyReportList() {
  router.push({ name: "DailyReport" })
}
</script>
<template>
  <div class="mx-auto p-4 w-50">
    <v-card
      class="p-4"
    >
      <h4 class="card-title mt-0 mb-4">
        {{ i18n.global.t('pages.dailyReports.combineRollbackForm.title') }}
      </h4>
      <CombineRollbackContent
        :deliveryPlan="props.deliveryPlan"
      />
      <ButtonArea
        v-model="isOpenConfirmModal"
        :isDisabled="hasError"
      />
    </v-card>
  </div>
  <RegisterModal
    v-model="isOpenConfirmModal"
    :title="i18n.global.t('pages.dailyReports.combineRollbackForm.registerModal.title')"
    :execCombineRollback="execCombineRollback"
  />
  <CompleteModal
    v-model="isDisplayCompleteModal"
    :messages="[
      i18n.global.t('pages.dailyReports.combineRollbackForm.completeModal.messageRow1'),
      i18n.global.t('pages.dailyReports.combineRollbackForm.completeModal.messageRow2')
    ]"
    :moveDailyReportDisplay="moveDailyReportList"
  />
</template>
